export default "__VITE_ASSET__65ab3ae1__"